<nuc-list-box class="package-types-container"
              title="Package type"
              subtitle="Select a package type you wish to download."
              [items]="packageTypes"
              [(selectedItem)]="selectedPackageType">
</nuc-list-box>
